import { v4 as uuidv4 } from "uuid";
import { NoteBlock } from "../block";
import { Implementation } from "../../../implementation";

export interface ImplementationBlock extends NoteBlock {
  "implementation-id": string;
  type: "omega/query-omega/page/block/implementation/ImplementationBlock";
}

export function isimplementationBlock(
  block: NoteBlock
): block is ImplementationBlock {
  return (block as ImplementationBlock)["implementation-id"] !== undefined;
}

export const newimplementationBlock = (config: {
  implementation: Implementation;
  blockIndex: number;
}) => {
  const { blockIndex, implementation } = config;
  const block: ImplementationBlock = {
    "implementation-id": implementation["implementation-id"],
    type: "omega/query-omega/page/block/implementation/ImplementationBlock",
    "block-index": blockIndex,
    "page-id": implementation["page-id"],
    "app-id": implementation["app-id"],
    "block-id": uuidv4(),
  };
  return block;
};
